import { a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import * as React from 'react';
import { s as styles } from '../../DataTable.module-bf72b311.js';
import { T as TableCell } from '../../index-83fc3c9d.js';
import { TableRow } from './TableRow.js';
import '../../ChevronRightIcon-b72559d2.js';
import '../../countries-34fea817.js';
import '../../index-177b9d11.js';
import '../../useId-f4885202.js';
import '../../CheckIcon-322b1ac3.js';
import '../../skeleton.module-7c98b8f8.js';
import '../../RowContext-011972fb.js';
import './Tooltip.js';
import '../../index-b7606a36.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import './IconButton.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../CloseIcon-25692563.js';
import '../../InfoIcon-22134611.js';
import '../../ThemeProvider-e3ab770b.js';

function createRow(rowData, columnDefs) {
    return columnDefs.map(function (def, index) {
        var Component = def.component;
        var item = rowData[index];
        return React.createElement(Component, __assign({ key: index }, item));
    });
}
function TableBody(props) {
    var rowsInfo = props.rowsInfo, columnDefs = props.columnDefs;
    var getCellClassNames = React.useCallback(function (column) {
        var _a;
        return classNames((_a = {},
            _a[styles.alignCenter] = columnDefs[column].align === "center",
            _a[styles.alignRight] = columnDefs[column].align === "right",
            _a));
    }, [columnDefs]);
    return (React.createElement("tbody", null, rowsInfo.map(function (row, rowIndex) {
        var cells = createRow(row.data, columnDefs);
        return (React.createElement(TableRow, { key: rowIndex, onClick: row.onClick, rowClassName: row.rowClassName, onMouseEnter: row.onMouseEnter, onMouseLeave: row.onMouseLeave }, cells.map(function (item, columnIndex) { return (React.createElement(TableCell, { key: item.key, className: getCellClassNames(columnIndex) }, item)); })));
    })));
}

export { TableBody };
